<template>
  <div>
    <h1 class="is-size-4">Serie</h1>
    <div class="columns">
      <div class="column is-half">
        <b-field label="Titolo">
          <b-input ref="iTitolo" v-model="filterModel.SeriesTitle" tabindex="1"></b-input>
        </b-field>

        <b-field label="Anno Inizio">
          <b-input ref="iAnnoInizio" v-model="filterModel.SeriesYearBegin" type="number" min="1800" max="2100"
            tabindex="3"></b-input>
        </b-field>

        <b-field label="Stato serie">
          <b-select ref="iSeriesStatus" v-model="filterModel.SeriesStatusId">
            <option v-for="x in lovs.seriesStatusForSeries" :value="x.Id" :key="x.Id">
              {{ x.SeriesStatus }}
            </option>
          </b-select>
        </b-field>


      </div>

      <div class="column">
        <b-field label="Titolo originale">
          <b-input ref="iTitoloOr" v-model="filterModel.SeriesOriginalTitle" tabindex="2"></b-input>
        </b-field>
        <b-field label="Anno Fine">
          <b-input ref="iAnnoFine" v-model="filterModel.SeriesYearEnd" type="number" min="1800" max="2100" tabindex="4">
          </b-input>
        </b-field>

      </div>
    </div>
    <div>
      <h1 class="is-size-4">Stagione</h1>
      <div class="columns">
        <div class="column">
          <b-field label="Numero stagione">
            <b-input ref="iNumber" v-model="filterModel.Number" type="number" tabindex="1"></b-input>
          </b-field>
          <b-field label="Data Inizio Visione">
            <b-datepicker ref="iDateBegin" v-model="filterModel.DateBegin" editable :date-formatter="isoDate">
            </b-datepicker>
          </b-field>
          <b-field label="Stato stagione">
            <b-select ref="iSeasonStatus" v-model="filterModel.StatusId">
              <option v-for="x in lovs.seriesStatusForSeasons" :value="x.Id" :key="x.Id">
                {{ x.SeriesStatus }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Commenti">
            <b-input type="textarea" v-model="filterModel.Comment"></b-input>
          </b-field>
          <section>
            <div class="buttons">
              <b-button @click="doOkSearch" type="is-primary">Vai</b-button>
              <b-button @click="doClearSearch" type="is-primary">Mastrolindo</b-button>
            </div>
          </section>
        </div>

        <div class="column">
          <b-field label="Servizio">
            <b-select ref="iService" v-model="filterModel.ServiceId">
              <option v-for="service in lovs.service" :value="service.Id" :key="service.Id">
                {{ service.Name }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Data Fine Visione">
            <b-datepicker ref="iDateEnd" v-model="filterModel.DateEnd" editable :date-formatter="isoDate"
              validation-message="Obbligatorio!">
            </b-datepicker>
          </b-field>
          <b-field label="Voto">
            <star-rating v-model="filterModel.Dicks" :show-rating="false" :increment="0.5" :star-size="30" />
          </b-field>
        </div>
      </div>



    </div>
  </div>

</template>

<script>
import helpers from "../helpers.js";
import api from "../api/api.js";
import StarRating from "vue-star-rating";
let emptyVal = { id: 0, Dicks: 0 };

export default {
  name: "SearchSeries",
  components: {StarRating},
  methods: {
    buildActiveLovs() {
      this.lovs.seriesStatus = this.lovs.seriesStatus.filter((x) => {
        return x.Active;
      });
      this.lovs.service = this.lovs.service.filter((x) => {
        return x.Active && x.Is_tv;
      });
      this.lovs.seriesStatusForSeries = this.lovs.seriesStatus.filter(
        (x) => !x.IsSeason
      );
      this.lovs.seriesStatusForSeasons = this.lovs.seriesStatus.filter(
        (x) => x.IsSeason
      );
    },

    isoDate(date) {
      return helpers.buildIsoDate(date);
    },
    doClearSearch() {
      this.filterModel = {};
    },
    doOkSearch() {
      this.$emit("OkSearchSeries", this.filterModel);
    },

  },
  data() {
    return {
      selectedRow: null,
      newItem: emptyVal,
      lovs: {mode:[],seriesStatus:[], service:[],seriesStatusForSeries:[],seriesStatusForSeasons:[]},
      filterModel: {}
    };
  },
  mounted() {

       const loading = this.$buefy.loading.open();
      api.lovs().then((data) => {
        this.lovs.language = data.data.languages;
        this.lovs.city = data.data.cities;
        this.lovs.friend = data.data.friends;
        this.lovs.mode = data.data.modes;
        this.lovs.service = data.data.services;
        this.lovs.seriesStatus = data.data.seriesStatuses;
        
        this.buildActiveLovs();
        loading.close();
      });
 
  },
};
</script>

<style>
</style>
